import { loadActiveSkin } from "@/lib/theme";
import { Header } from "./header";
import { HeaderV2 } from "./v2/header-v2";

/**
 * Skin-aware header — picks V1 or V2 layout based on the active skin
 * stored in Setting.theme.active_skin.
 */
export async function SiteHeader() {
  const skin = await loadActiveSkin();
  if (skin === "v2") return <HeaderV2 />;
  return <Header />;
}
